import DateTimeRange from 'admin/components/atoms/DateTimeRange';
import {
  DateRangeOption,
  DateRangeSelector,
  EXTENDED_OPTIONS,
} from 'admin/components/molecules/DateRangeSelector';
import Button from 'admin/components/shared/Button';
import { toQueryParams } from 'admin/utils';
import moment from 'moment';
import qs from 'query-string';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { useAppSelector } from '~/javascripts/admin/hooks/useApp';
import { selectUserPrivateMoney } from '~/javascripts/admin/reducers/user-private-money';

type Props = {
  onQueryChange: (args: {
    dashboardQuery: string;
    accountStatisticsQuery: string;
    privateMoneyId: string;
  }) => Promise<void>;
};

const FilterFormWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  margin: 28px 0 14px 0;
`;

const SearchButton = styled(Button)``;

const FilterForm = ({ onQueryChange }: Props) => {
  const location = useLocation();
  const userPrivateMoney = useAppSelector(selectUserPrivateMoney);
  const params = qs.parse(location.search.slice(1));

  const [selectedPeriod, setSelectedPeriod] = useState<DateRangeOption>('thisMonth');
  const [dateRange, setDateRange] = useState<{
    from?: moment.Moment | null;
    to?: moment.Moment | null;
  }>({
    from: params.from ? moment(params.from) : moment().startOf('month'),
    to: params.to ? moment(params.to) : moment().endOf('day'),
  });

  const toQueryFilterParams = (range: typeof dateRange, moneyId?: string) => {
    let prms: Record<string, string | moment.Moment> = moneyId ? { private_money_id: moneyId } : {};

    if (range?.from) {
      prms = { ...prms, from: range.from };
    }
    if (range?.to) {
      prms = { ...prms, to: range.to };
    }
    return toQueryParams(prms);
  };

  const handleQueryChange = (range: typeof dateRange) => {
    const dashboardQuery = toQueryFilterParams(range, userPrivateMoney.id);
    const accountStatisticsQuery = toQueryFilterParams(range);

    onQueryChange({ dashboardQuery, accountStatisticsQuery, privateMoneyId: userPrivateMoney.id });
  };

  const handleDateRangeChange = (
    period: DateRangeOption,
    range: { from: moment.Moment; to: moment.Moment }
  ) => {
    setSelectedPeriod(period);
    const newDateRange = { from: range.from, to: range.to };
    setDateRange(newDateRange);
    handleQueryChange(newDateRange);
  };

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    handleQueryChange(dateRange);
  };

  useEffect(() => {
    handleQueryChange(dateRange);
  }, [userPrivateMoney]);

  return (
    <FilterFormWrapper>
      <DateRangeSelector
        value={selectedPeriod}
        onChange={handleDateRangeChange}
        options={EXTENDED_OPTIONS}
      />
      <DateTimeRange
        dateRange={dateRange}
        setDateRange={setDateRange}
        wrapperStyles={{ marginBottom: 0 }}
        dateTimeProps={{
          fromProps: { showIcon: true },
          toProps: { showIcon: true },
        }}
      />
      <SearchButton onClick={onSubmit}>計算</SearchButton>
    </FilterFormWrapper>
  );
};

export default FilterForm;
